import {
  RoundCreationSettingsResponse,
  RoundCreationSettingsUpdate,
  RoundPreviewRequest,
  RoundPreviewResponse,
  RoundRebuildRequest,
  RoundRebuildResponse,
} from '../../data-models/round-creation-settings.data-model';
import { MaggieHttp } from '../MaggieHttp';

const BASE = '/round-creation-settings';

/** A rebuild replans and recalculates every company in scope; the default 60s ceiling is too short. */
const REBUILD_TIMEOUT_MS = 15 * 60_000;

/** A preview replans one company from nothing, which outruns the default ceiling on a long history. */
const PREVIEW_TIMEOUT_MS = 6 * 60_000;

/** The securities option list. Served by the API so it cannot drift from what the engine recognises. */
export async function getRoundSecurityTypes() {
  const { data } = await MaggieHttp.maggie.get<{ securityTypes: string[] }>(`${BASE}/security-types`);
  return data.securityTypes;
}

export async function getRoundCreationSettings() {
  const { data } = await MaggieHttp.maggie.get<RoundCreationSettingsResponse>(BASE);
  return data;
}

export async function updateRoundCreationSettings(payload: RoundCreationSettingsUpdate) {
  const { data } = await MaggieHttp.maggie.put<RoundCreationSettingsUpdate, RoundCreationSettingsResponse>(
    BASE,
    payload
  );
  return data;
}

export async function previewRoundCreationSettings(payload: RoundPreviewRequest) {
  const { data } = await MaggieHttp.maggie.post<RoundPreviewRequest, RoundPreviewResponse>(
    `${BASE}/preview`,
    payload,
    { timeout: PREVIEW_TIMEOUT_MS }
  );
  return data;
}

/**
 * Saves the settings and applies them under the given scope. Under ALL the API answers 409 until the
 * request carries the live hand-edited count; that round trip is the contract, not an error.
 */
export async function rebuildRounds(payload: RoundRebuildRequest) {
  const { data } = await MaggieHttp.maggie.post<RoundRebuildRequest, RoundRebuildResponse>(
    `${BASE}/rebuild`,
    payload,
    { timeout: REBUILD_TIMEOUT_MS, skipSentryStatuses: [409] }
  );
  return data;
}
